import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../../utils/baseQueryWithReauth';

export const tutorDetailsApi = createApi({
  reducerPath: 'tutorDetailsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    updatePassword: builder.mutation({
      query: ({OldPassword, NewPassword, ConfirmPassword}) => ({
        url: "/WebTutor/UpdateTutorPassword",
        method: "Post",
        params: {OldPassword, NewPassword, ConfirmPassword}
      }),
    }),
    getTutorDashboard: builder.query({
      query: ({ pageNumber = 1, pageSize = 10, search = '' }) => ({
        url: `/WebTutor/GetAllDashboardDetails`,
        method: "Get",
        params: {pageNumber, pageSize, search}
      })
    }),
    getTutorNotifications: builder.query({
      query: () => ({
        url: `/WebTutor/GetAllTutorNotification`,
        method: "GET",
      }),
    }),
  }),
});

export const { 
  useUpdatePasswordMutation,
  useGetTutorDashboardQuery,
  useGetTutorNotificationsQuery
} = tutorDetailsApi;